import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { LOCALES, switchPath, useLocale } from '../i18n'

// Non-redirecting language hint: if the browser prefers a locale we support but the reader is on a
// different one, offer a dismissible link. NO geo/auto-redirect (bad for SEO) — just a nudge, using
// the same navigator.language signal as the LaneSearch geo nudge. Client-only; dismissal persists.
export function LangNudge() {
  const active = useLocale()
  const { pathname } = useLocation()
  const [suggest, setSuggest] = useState<(typeof LOCALES)[number] | null>(null)

  useEffect(() => {
    if (typeof navigator === 'undefined') return
    const tags = [navigator.language, ...(navigator.languages ?? [])]
    const prefLang = tags
      .map((t) => t.slice(0, 2).toLowerCase())
      .find((l) => LOCALES.some((x) => x.code === l))
    if (!prefLang || prefLang === active) return
    if (localStorage.getItem(`langNudge:${prefLang}:dismissed`)) return
    setSuggest(LOCALES.find((x) => x.code === prefLang) ?? null)
  }, [active])

  if (!suggest) return null
  const label =
    suggest.code === 'de'
      ? 'Diese Seite auf Deutsch ansehen?'
      : `View this page in ${suggest.label}?`
  const cta = suggest.code === 'de' ? 'Auf Deutsch' : suggest.label

  return (
    <div className="glass border-b border-border">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-5 py-2 text-sm">
        <div className="flex items-center gap-2 text-muted">
          {suggest.flag}
          <span>{label}</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={switchPath(suggest.code, pathname)}
            hrefLang={suggest.hreflang}
            className="font-semibold text-link hover:underline"
          >
            {cta} →
          </a>
          <button
            type="button"
            aria-label="Dismiss"
            onClick={() => {
              localStorage.setItem(`langNudge:${suggest.code}:dismissed`, '1')
              setSuggest(null)
            }}
            className="text-muted hover:text-ink"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  )
}
